/* Keep personalization before Pumper without replacing either app's nodes. */
(() => {
  'use strict';
  let pending = false;
  function arrange() {
    pending = false;
    const personalization = document.getElementById('tee-artwork-form');
    const bundle = document.getElementById('svelte-bundle-widget');
    if (!personalization || !bundle) return;
    const parent = personalization.parentElement;
    // Only handle the verified sibling layout; never move between product forms.
    if (!parent || bundle.parentElement !== parent) return;
    if (!(bundle.compareDocumentPosition(personalization) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
    parent.insertBefore(bundle, personalization.nextSibling);
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(arrange);
  }
  function start() {
    const root = document.getElementById('MainContent');
    if (!root) return;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    arrange();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
